import {
    SET_TRACKIER_PUBLISHER,
    CLEAR_TRACKIER_PUBLISHER,
    GET_TRACKIER_PUBLISHER_SUCCESS,
    GET_TRACKIER_PUBLISHER_FAILED,
} from '../../actions/type';

const initialState = { data: null, status: 'idle' };

export default function voluumPublisherReducer(state = initialState, action) {
    const { type, data } = action;

    switch (type) {
        case SET_TRACKIER_PUBLISHER:
            return {
                ...state,
                data,
            }
        case CLEAR_TRACKIER_PUBLISHER:
            return {
                ...state,
                data: null,
            }
        case GET_TRACKIER_PUBLISHER_SUCCESS:
            return {
                ...state,
                status: 'success',
            }
        case GET_TRACKIER_PUBLISHER_FAILED:
            return {
                ...state,
                error: data,
                status: 'failed',
            }

        default:
            return state;
    }
}